export const conf2ChatSessionId = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
